/**
 * Lead-source presentation helpers, shared by the board and the detail page so
 * they never disagree on how a source reads.
 */

const LABELS = {
  CARSALES: 'Carsales',
  DRIVE: 'Drive',
  CAREXPERT: 'CarExpert',
  AUTOTRADER: 'Autotrader',
  FACEBOOK_MARKETPLACE: 'Facebook',
  WEB_FORM: 'Web form',
  PHONE: 'Phone',
  WALK_IN: 'Walk-in',
  WHATSAPP: 'WhatsApp',
  SMS: 'SMS',
  EMAIL: 'Email',
  DEAD_LEAD_REVIVAL: 'Revived',
};

/** Human-friendly source label (e.g. DEAD_LEAD_REVIVAL → "Revived"). */
export function sourceLabel(src) {
  if (!src) return '—';
  return LABELS[src] || src.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

/** True when the lead came from the dead-lead revival engine. */
export function isRevival(src) {
  return src === 'DEAD_LEAD_REVIVAL';
}

/**
 * System-generated notes the dead-lead engine stamps onto a lead
 * (e.g. "Reactivated from lost-lead pool <uuid>"). These carry a raw UUID and
 * add no value on a card — the detail page surfaces the origin properly.
 */
const SYSTEM_NOTE_RE = /^(reactivated from dead-lead|promoted from dead-lead|batched from pool)/i;
export function isSystemNote(s) {
  return !!s && SYSTEM_NOTE_RE.test(String(s).trim());
}
